function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"
    )
  );
}

const trapFocusHandlers = {};
const warningTime = 3000;

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });

  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });

  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("product-model")
    .forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function extractContent(string) {
  var div = document.createElement("div");
  div.innerHTML = string;

  return div.textContent || div.innerText;
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];

    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");

    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");

    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);

    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");

      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.getCart = function (callback) {
  $.getJSON("/cart.js", function (cart, textStatus) {
    if (typeof callback === "function") {
      callback(cart);
      setTimeout(function () {}, 2000);
    } else {
      Shopify.onCartUpdate(cart);
    }
  });
};

Shopify.onCartUpdate = function (cart) {
  updateStickyFooterPrice();
  // console.log('There are now ' + cart.item_count + ' items in the cart.');
};

// Helpers
function asStr(v){ return v == null ? '' : String(v); }
function isWarrantyItem(item) {
  return item?.properties && (asStr(item.properties._is_warranty).toLowerCase() === 'true');
}
function isChildUpsell(item) {
  return item?.properties && (asStr(item.properties._is_child).toLowerCase() === 'true');
}
function linkMatches(li, mainItem) {
  if (!li || !mainItem) return false;
  const byVariant = li.properties && String(li.properties._parent_variant_id) === String(mainItem.variant_id);
  const byHandle  = li.properties && li.properties._upsell_handle && mainItem.product_handle &&
                    String(li.properties._upsell_handle).toLowerCase() === String(mainItem.product_handle).toLowerCase();
  const byKey     = li.properties && li.properties._parent_key && li.properties._parent_key === mainItem.key;
  return Boolean(byVariant || byHandle || byKey);
}
function unitsPerParent(li) {
  const n = li?.properties?._units_per_parent;
  const v = Number(n);
  return Number.isFinite(v) && v > 0 ? v : 1;
}
function desiredChildQtyFor(mainQty, childLi) {
  return Math.max(0, Math.floor(mainQty * unitsPerParent(childLi)));
}
function getLinkedChildrenForVariant(cart, parentVariantId, parentHandle){
  const pv = asStr(parentVariantId);
  const ph = asStr(parentHandle).toLowerCase();

  return cart.items.filter((it) => {
    if (!isChildUpsell(it)) return false;
    const childParentVid = asStr(it.properties?._parent_variant_id);
    const childHandle    = asStr(it.properties?._upsell_handle).toLowerCase();

    // Prefer exact variant match; otherwise fallback to handle match
    if (childParentVid) return childParentVid === pv;
    if (childHandle && ph) return childHandle === ph;
    return false;
  });
}
function findExistingChildForVariant(cart, parentVariantId, childVariantId) {
  return cart.items.find(li =>
    li?.properties?._is_child === true &&
    String(li.properties._parent_variant_id) === String(parentVariantId) &&
    parseInt(li.variant_id, 10) === parseInt(childVariantId, 10)
  );
}
// End Helpers

Shopify.addItem = function (variant_id, quantity, callback, input = null) {
  let can_order = true;
  quantity = quantity || 1;

  const itemsToAdd = [];
  const itemsToUpdate = [];
  const itemsToRemove = [];

  let attached_variant = "";
  let isWarranty = false;
  let warrantyProperties = {};

  const warrantyCheckbox = document.querySelector(".add_extended_warranty");
  let warranty_product = parseInt(warrantyCheckbox?.value);

  if (warrantyCheckbox && warrantyCheckbox.checked) {
    isWarranty = true;
    const labelFor = document.getElementById("product_main_title").innerHTML;
    const extWarrantyOf = document.getElementById("extWarrantyOf").value;

    warrantyProperties = {
      [labelFor]: extWarrantyOf,
      _is_warranty: true,
      _variantId: String(variant_id),
    };
  }

  // MAIN PRODUCT PROPERTIES (unchanged bits)
  let mainProperties = { "Screen Size": jQuery(".screen_size").val() };

  const isArabicStore = ['uae', 'ksa', 'ksa-virgin'].includes(global_store);
  const tags = window.productTags || [];

  const isLaptop = tags.includes("Mackbooks") || tags.includes("Macbooks") || tags.includes("Laptops");

  const isMicrosoftSurface = tags.includes("Microsoft Surface");

  if (isArabicStore) {
    const keyboardValue = jQuery("input[name='keyboards']:checked").val();
    if (keyboardValue !== undefined) {
      mainProperties["Keyboard"] = keyboardValue;
    }
  } else {
    if (isLaptop && !isMicrosoftSurface) {
      mainProperties["Keyboard"] = "English";
    }
  }

  const fbr_variants = window.fbr_variants;
  if (variant_id in fbr_variants) {
    if (document.documentElement.lang === "ar") {
      mainProperties["ريڤايب اكسبرس"] = (global_store === "za") ? "توصيل خلال 2-3 أيام" : "توصيل خلال 24 ساعة";
    } else {
      mainProperties["Revibe Express"] = (global_store === "za") ? "2-3 Days Delivery" : "24 Hours Delivery";
    }
  }

  const condInputEl = document.querySelector('#laptop_condition');
  if (condInputEl && condInputEl.value && condInputEl.value.trim() !== '') {
    mainProperties[document.documentElement.lang === "ar" ? "الحالة" : "Condition"] = condInputEl.value.trim();
  }
  if (isWarranty) mainProperties["_variantId"] = String(warranty_product);

  // ✅ NEW: gather selected upsells this time
  const crossSaleProducts = document.querySelectorAll("input[name='cross-sale']:checked");
  const mainHandleEl = document.querySelector("[data-product-handle]");
  let mainHandle = mainHandleEl ? (mainHandleEl.getAttribute("data-product-handle") || "") : "";
  if (!mainHandle && typeof bcpo_product !== "undefined" && bcpo_product?.handle) mainHandle = bcpo_product.handle;
  if (!mainHandle) {
    const m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (m) mainHandle = decodeURIComponent(m[1]);
  }
  mainHandle = (mainHandle || "").toLowerCase();

  // FETCH CART
  fetch("/cart.js")
    .then((res) => res.json())
    .then((cart) => {
      // enrich each item with product_handle for linking by handle where needed
      cart.items.forEach(li => { try { li.product_handle = li?.url?.split('/products/')[1]?.split('?')[0] || ""; } catch(_){} });

      let mainFound = false;
      let warrantyFound = false;
      let existingMainItem = null;

      for (const variant of bcpo_product.variants) {
        if (parseInt(variant.id) === parseInt(variant_id)) {
          attached_variant = variant.title;
          if (parseInt(variant.price) === 0 || parseInt(variant.inventory_quantity) === 0) {
            can_order = false;
            break;
          }
        }
      }

      for (const item of cart.items) {
        if (item.variant_id === parseInt(variant_id)) {
          existingMainItem = item;

          const hasWarranty = item.properties && item.properties._variantId;
          if (isWarranty && !hasWarranty) {
            // re-add main with warranty prop
            itemsToRemove.push({ key: item.key });
          } else {
            itemsToUpdate.push({ key: item.key, quantity: item.quantity + quantity });
            mainFound = true;
          }
        }

        if (
          item.variant_id === warranty_product &&
          isWarrantyItem(item) &&
          item.properties._variantId === String(variant_id)
        ) {
          itemsToUpdate.push({ key: item.key, quantity: item.quantity + quantity });
          warrantyFound = true;
        }
      }

      // Calculate desired final main qty
      let finalMainQty = quantity + (existingMainItem ? existingMainItem.quantity : 0);
      const delta = existingMainItem ? (finalMainQty - existingMainItem.quantity) : finalMainQty;

      // Add main product if not present (or after removal for warranty)
      if (!mainFound) {
        itemsToAdd.push({
          id: variant_id,
          quantity: finalMainQty,
          properties: mainProperties,
        });
      }

      // Add warranty if needed
      if (isWarranty && !warrantyFound) {
        itemsToAdd.push({
          id: warranty_product,
          quantity: finalMainQty,
          properties: warrantyProperties,
        });
      }

      // 🔗 Find already-linked child upsells for this main variant
      const linkedChildren = getLinkedChildrenForVariant(cart, variant_id, mainHandle);

      // ✅ NEW: If upsells were selected in this add,
      // add/tune them to match the final main qty.
      if (crossSaleProducts.length > 0) {
        crossSaleProducts.forEach((checkbox) => {
          const childVariantId = parseInt(checkbox.value, 10);
          const labelFor = document.getElementById("product_main_title").innerHTML;
          const labelFor2 = document.documentElement.lang === "ar" ? "قم بالبيع مع" : "Upsell with";

          // does this exact upsell already exist linked to this main?
          const existingChild = findExistingChildForVariant(cart, variant_id, childVariantId);

          if (existingChild) {
            // set to final main qty * units_per_parent
            const desiredQty = desiredChildQtyFor(finalMainQty, existingChild);
            if (desiredQty !== existingChild.quantity) {
              itemsToUpdate.push({ key: existingChild.key, quantity: desiredQty });
            }
          } else {
            // add fresh child, link to parent (by variant id; key will be known after add)
            itemsToAdd.push({
              id: childVariantId,
              quantity: finalMainQty,               // 1:1 with parent by default
              properties: {
                [labelFor2]: labelFor,
                _is_child: true,
                _parent_variant_id: String(variant_id),
                _sync_with_parent: "qty",
                _parent_title: labelFor,
                _parent_variant_title: attached_variant,
                _upsell_handle: mainHandle
              },
            });
          }
        });
      } else {
        // No new upsells selected this time.
        // If user is adding the same main again, keep already-linked upsells in sync (+delta).
        if (delta > 0 && linkedChildren.length) {
          linkedChildren.forEach((child) => {
            const desiredQty = desiredChildQtyFor(finalMainQty, child);
            if (desiredQty !== child.quantity) {
              itemsToUpdate.push({ key: child.key, quantity: desiredQty });
            }
          });
        }
      }

      // Battery upsell (kept as-is)
      const batteryCheckbox = document.getElementById("brand_new_battery_checkbox");
      if (can_order && batteryCheckbox && batteryCheckbox.checked) {
        const battery_product = batteryCheckbox.value;
        if (battery_product) {
          const labelFor = document.documentElement.lang === "ar"
            ? "بطارية جديدة بصحة 100٪؜ لجهاز"
            : "New 100% battery Upgrade for";
          itemsToAdd.push({
            id: battery_product,
            quantity: 1,
            properties: { [labelFor]: jQuery(".productView-title span").html() },
          });
        }
      }

      // Sequential ops (unchanged)
      const removeSequentially = (items) =>
        items.reduce((p, item) =>
          p.then(() =>
            fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: item.key, quantity: 0 }),
            })
          ), Promise.resolve());

      const updateSequentially = (items) =>
        items.reduce((p, item) =>
          p.then(() =>
            fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: item.key, quantity: item.quantity }),
            })
          ), Promise.resolve());

      return removeSequentially(itemsToRemove)
        .then(() => updateSequentially(itemsToUpdate))
        .then(() => {
          if (itemsToAdd.length > 0) {
            return $.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: JSON.stringify({ items: itemsToAdd }),
              dataType: "json",
              contentType: "application/json",
            });
          }
        });
    })
    .then(() => {
      if (typeof callback === "function") {
        // Skip side cart drawer and warranty modal — go straight to cart page
        var _sl = window.Shopify;
        var _cartLocale = '';
        if (_sl && _sl.locale !== _sl.primaryLocale && _sl.locale.indexOf('en') !== 0) {
          var _m = window.location.pathname.match(/^(\/[a-z]{2}(?:-[a-zA-Z]{2,4})?)(\/|$)/i);
          _cartLocale = _m ? _m[1] : '/' + _sl.locale;
        }
        window.location.href = _cartLocale + '/cart';
      } else {
        Shopify.onItemAdded();
      }
    })
    .catch((err) => {
      console.error("❌ Cart update failed", err);
      const message = input
        ? getInputMessage(parseInt(input.attr("data-inventory-quantity")))
        : window.cartStrings.addProductOutQuantity2;
      if (input) input.val(parseInt(input.attr("data-inventory-quantity")));
      Shopify.onError(err, "error", message);
    });
};

Shopify.changeItem = async function (mainItemKey, newQuantity, callback) {
  const $cart = $("[data-cart]");
  const loadingClass = "is-loading";
  const overlay = '<div class="loading-overlay loading-overlay--custom">...</div>';
  $cart.addClass(loadingClass).prepend(overlay);

  const $cartDropdown = $("#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper");
  $cartDropdown.addClass(loadingClass).prepend(overlay);
  const sideCart = document.querySelector('#halo-cart-sidebar');
  if (sideCart && !sideCart.classList.contains('is-loading-side-cart')) sideCart.classList.add('is-loading-side-cart');

  try {
    const cart = await (await fetch("/cart.js")).json();
    cart.items.forEach(li => { try { li.product_handle = li?.url?.split('/products/')[1]?.split('?')[0] || ""; } catch(_){} });

    const updates = {};
    const mainItem = cart.items.find(item => item.key === mainItemKey);
    if (!mainItem) throw new Error("Main item not found.");

    updates[mainItem.key] = newQuantity;

    // warranty (existing logic)
    const warrantyItem = cart.items.find(item =>
      isWarrantyItem(item) &&
      String(item.properties._variantId) === String(mainItem.variant_id)
    );
    if (warrantyItem) updates[warrantyItem.key] = newQuantity;

    // ✅ NEW: linked upsell children
    const parentHandle = (mainItem.product_handle || (mainItem.url?.split('/products/')[1] || '').split('?')[0] || '').toLowerCase();

    const children = getLinkedChildrenForVariant(cart, mainItem.variant_id, parentHandle);
    children.forEach(child => {
      const desired = desiredChildQtyFor(newQuantity, child); // keep your helper
      if (desired !== child.quantity) updates[child.key] = desired;
    });

    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates }),
    });

    const updatedCart = await (await fetch("/cart.js")).json();
    if (typeof callback === "function") callback(updatedCart);
    updateStickyFooterPrice(false);

  } catch (err) {
    console.error("Error updating item + links:", err);
    Shopify.onError(err, "error", "Error updating cart item.");
  } finally {
    setTimeout(() => $cart.removeClass(loadingClass).find(".loading-overlay--custom").remove(), 500);
    if (sideCart && sideCart.classList.contains('is-loading-side-cart')) sideCart.classList.remove('is-loading-side-cart');
  }
};


Shopify.onItemAdded = function (line_item) {
  // Custom function after item is added to cart
  updateStickyFooterPrice();
};

Shopify.onError = function (XMLHttpRequest, textStatus, message) {
  var data = eval("(" + XMLHttpRequest.responseText + ")");
  if (!!data.message) {
    alert(data.message + "(" + data.status + "): " + data.description);
  } else {
    alert("Error : " + Shopify.fullMessagesFromErrors(data).join("; ") + ".");
  }
};

Shopify.fullMessagesFromErrors = function (errors) {
  var fullMessages = [];
  for (var attribute in errors) {
    for (var i = 0; i < errors[attribute].length; i++) {
      fullMessages.push(attribute + " " + errors[attribute][i]);
    }
  }
  return fullMessages;
};

// Shopify.removeItem = async function (lineItemKey, callback) {

//   const $cart = $("[data-cart]");
//   const loadingClass = "is-loading";
//   const $cartLoading =
//     '<div class="loading-overlay loading-overlay--custom">\
//       <div class="loading-overlay__spinner">\
//         <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
//           <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
//         </svg>\
//       </div>\
//     </div>';

//   // ✅ Start loading
//   $cart.addClass(loadingClass).prepend($cartLoading);

//   // add loading on sidebar
//   const $cartDropdown = $(
//     "#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper"
//   );
//   const $cartDropdownLoading =
//     '<div class="loading-overlay loading-overlay--custom">\
//                   <div class="loading-overlay__spinner">\
//                       <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
//                           <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
//                       </svg>\
//                   </div>\
//               </div>';
//   //const loadingClass = "is-loading";

//   $cartDropdown.addClass(loadingClass).prepend($cartDropdownLoading);

//   const sideCart = document.querySelector('#halo-cart-sidebar');

//   if (sideCart && !sideCart.classList.contains('is-loading-side-cart')) {
//     sideCart.classList.add('is-loading-side-cart');
//   }

//   try {
//     const res = await fetch("/cart.js");
//     const cart = await res.json();

//     const itemToRemove = cart.items.find(item => item.key === lineItemKey);
//     if (!itemToRemove) throw new Error("Item not found in cart.");

//     const updates = {};
//     let reAddMainItem = null;

//     // ✅ Case 1: Removing a WARRANTY
//     if (itemToRemove.properties && itemToRemove.properties._is_warranty) {
//       updates[lineItemKey] = 0;

//       const mainProduct = cart.items.find(item =>
//         item.key !== lineItemKey &&
//         item.properties &&
//         String(item.properties._variantId) === String(itemToRemove.variant_id) &&
//         !item.properties._is_warranty
//       );

//       if (mainProduct) {
//         const shouldRemoveMain =
//           mainProduct.properties._variantId && mainProduct.quantity === 1;

//         if (shouldRemoveMain) {
//           updates[mainProduct.key] = 0;

//           const isDiscounted = mainProduct.discounted_price < mainProduct.line_price;

//           if (!isDiscounted) {
//             const cleanedProps = { ...mainProduct.properties };
//             delete cleanedProps._variantId;

//             reAddMainItem = {
//               id: mainProduct.variant_id,
//               quantity: 1,
//               properties: cleanedProps,
//             };
//           }
//         }
//       }

//     // ✅ Case 2: Removing MAIN product (also remove warranty)
//     } else if (itemToRemove.properties && itemToRemove.properties._variantId) {
//       updates[lineItemKey] = 0;

//       const warrantyItem = cart.items.find(item =>
//         item.properties &&
//         item.properties._is_warranty &&
//         String(item.properties._variantId) === String(itemToRemove.variant_id)
//       );

//       if (warrantyItem) {
//         updates[warrantyItem.key] = 0;
//       }

//     // ✅ Case 3: Standalone item
//     } else {
//       updates[lineItemKey] = 0;
//     }

//     // 🔁 Remove items
//     await fetch("/cart/update.js", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json"
//       },
//       body: JSON.stringify({ updates })
//     });

//     // ♻️ Re-add main product (cleaned)
//     if (reAddMainItem) {
//       await new Promise(resolve => setTimeout(resolve, 300));
//       await fetch("/cart/add.js", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json"
//         },
//         body: JSON.stringify(reAddMainItem)
//       });
//       console.log("Re-added cleaned main product");
//     }

//     // 🔄 Refresh cart
//     const updatedRes = await fetch("/cart.js");
//     const updatedCart = await updatedRes.json();

//     if (typeof callback === "function") {
//       callback(updatedCart);
//     }

//     updateStickyFooterPrice(false);

//   } catch (err) {
//     console.error("Error in removeItem:", err);
//     Shopify.onError(err, "error", "Error removing item.");
//   } finally {
//     // ✅ End loading
//     //$cart.removeClass(loadingClass).find(".loading-overlay--custom").remove();
//     setTimeout(function () {
//       $cart.removeClass(loadingClass).find(".loading-overlay--custom").remove();
//     }, 500);
//     if (sideCart && sideCart.classList.contains('is-loading-side-cart')) {
//       sideCart.classList.remove('is-loading-side-cart');
//     }
//   }
// };

Shopify.removeItem = async function (lineItemKey, callback) {
  const $cart = $("[data-cart]");
  const loadingClass = "is-loading";
  const overlay = '<div class="loading-overlay loading-overlay--custom">...</div>';
  $cart.addClass(loadingClass).prepend(overlay);

  const $cartDropdown = $("#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper");
  $cartDropdown.addClass(loadingClass).prepend(overlay);
  const sideCart = document.querySelector('#halo-cart-sidebar');
  if (sideCart && !sideCart.classList.contains('is-loading-side-cart')) sideCart.classList.add('is-loading-side-cart');

  try {
    const cart = await (await fetch("/cart.js")).json();
    // derive product handle once for all line items
    cart.items.forEach(li => { try { li.product_handle = li?.url?.split('/products/')[1]?.split('?')[0] || ""; } catch(_){} });

    const itemToRemove = cart.items.find(item => item.key === lineItemKey);
    if (!itemToRemove) throw new Error("Item not found in cart.");

    const updates = {};
    let reAddMainItem = null;

    // --- CASE A: removing a WARRANTY ---
    if (isWarrantyItem(itemToRemove)) {
      updates[lineItemKey] = 0;

      const mainProduct = cart.items.find(item =>
        item.key !== lineItemKey &&
        item.properties &&
        asStr(item.properties._variantId) === asStr(itemToRemove.variant_id) &&
        !isWarrantyItem(item)
      );

      if (mainProduct) {
        const shouldRemoveMain = mainProduct.properties._variantId && mainProduct.quantity === 1;
        if (shouldRemoveMain) {
          updates[mainProduct.key] = 0;
          const isDiscounted = mainProduct.discounted_price < mainProduct.line_price;
          if (!isDiscounted) {
            const cleanedProps = { ...mainProduct.properties };
            delete cleanedProps._variantId;
            reAddMainItem = { id: mainProduct.variant_id, quantity: 1, properties: cleanedProps };
          }
        }
      }

    // --- CASE B: removing a MAIN product (with or without warranty) ---
    } else if (!isChildUpsell(itemToRemove)) {
      // Treat any non-warranty, non-child item as a MAIN
      updates[lineItemKey] = 0;

      // remove matching warranty if any
      const warrantyItem = cart.items.find(item =>
        isWarrantyItem(item) &&
        asStr(item.properties._variantId) === asStr(itemToRemove.variant_id)
      );
      if (warrantyItem) updates[warrantyItem.key] = 0;

      // remove children linked by parent variant id OR fallback handle
      const children = getLinkedChildrenForVariant(cart, itemToRemove.variant_id, itemToRemove.product_handle);
      children.forEach(child => { updates[child.key] = 0; });

    // --- CASE C: removing a CHILD upsell (do not touch main) ---
    } else {
      updates[lineItemKey] = 0;
    }

    // apply removals
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates }),
    });

    // optional re-add (cleaned main after warranty removal)
    if (reAddMainItem) {
      await new Promise(r => setTimeout(r, 300));
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(reAddMainItem)
      });
    }

    const updatedCart = await (await fetch("/cart.js")).json();
    if (typeof callback === "function") callback(updatedCart);
    updateStickyFooterPrice(false);

  } catch (err) {
    console.error("Error in removeItem:", err);
    Shopify.onError(err, "error", "Error removing item.");
  } finally {
    setTimeout(() => $cart.removeClass(loadingClass).find(".loading-overlay--custom").remove(), 500);
    if (sideCart && sideCart.classList.contains('is-loading-side-cart')) sideCart.classList.remove('is-loading-side-cart');
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add("overflow-hidden-mobile");
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");

      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });

      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove("overflow-hidden-mobile");
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");

        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add("overflow-hidden-mobile");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class UpdateQuantity extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.querySelectorAll(".btn-quantity").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }
  onButtonClick(event) {
    event.preventDefault();
    let el_input = event.target.parentElement.querySelector(".quantity");
    const value = Number(el_input.value);
    const inStockNumber = el_input.dataset.inventoryQuantity;
    if (event.target.classList.contains("plus")) {
      var newVal = value + 1;
    } else {
      var newVal = value - 1;
    }

    if (newVal < 0) {
      var newVal = 1;
    }

    if (newVal > inStockNumber) {
      const message = getInputMessage(inStockNumber);
      showWarning(message, warningTime);
      var newVal = inStockNumber;
    }

    el_input.value = newVal;
    this.input.dispatchEvent(this.changeEvent);
  }
}

class UpdateQuantityQuickShop extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.querySelectorAll(".btn-quantity").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    let el_input = event.target.parentElement.querySelector(".quantity");
    const value = Number(el_input.value);
    const inStockNumber = el_input.dataset.inventoryQuantity;

    if (event.target.classList.contains("plus")) {
      var newVal = value + 1;
    } else {
      var newVal = value - 1;
    }

    if (newVal < 0) {
      var newVal = 1;
    }

    if (newVal > inStockNumber) {
      const message = getInputMessage(inStockNumber);
      showWarning(message, warningTime);
      var newVal = inStockNumber;
    }

    el_input.value = newVal;
    this.input.dispatchEvent(this.changeEvent);
    const quickshop = this.closest("[data-quickshop]");
    const realQuantityInput = quickshop.querySelector(
      'form input[type="hidden"]'
    );
    realQuantityInput.setAttribute("value", newVal);
  }
}

window.addEventListener("load", () => {
  customElements.define("cart-update-quantity", UpdateQuantity);
  customElements.define("quickshop-update-quantity", UpdateQuantityQuickShop);
});

function showWarning(content, time = null) {
  if (window.warningTimeout) {
    clearTimeout(window.warningTimeout);
  }
  const warningPopupContent = document
    .getElementById("halo-warning-popup")
    .querySelector("[data-halo-warning-content]");
  warningPopupContent.textContent = content;
  document.body.classList.add("has-warning");

  if (time) {
    window.warningTimeout = setTimeout(() => {
      document.body.classList.remove("has-warning");
    }, time);
  }
}

function getInputMessage(maxValue) {
  var message = window.cartStrings.addProductOutQuantity.replace(
    "[maxQuantity]",
    maxValue
  );
  return message;
}
function updateStickyFooterPrice(showLoader = true) {
  //console.log("updateStickyFooter called");

  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const total = (cart.items_subtotal_price / 100).toFixed(2); // Convert cents to dollars
      const formattedTotal = new Intl.NumberFormat("en-US").format(total);

      //console.log("Cart total fetched:", formattedTotal);

      // Select all elements with the class `.cart-total-amount-sticky`
      const stickyFooters = document.querySelectorAll(
        ".cart-total-amount-sticky"
      );

      // Loop through each element and update its inner HTML
      // stickyFooters.forEach((stickyFooter) => {
      //   stickyFooter.innerHTML = global_currency + " " + formattedTotal;
      // });
      if($("body").hasClass("template-cart")){
        updateCart(cart, showLoader);
      } else {
        updateSidebarCart(cart, showLoader);
      }
    })
    .catch((error) => {
      console.error("Error updating sticky footer price:", error);
    });
}

function addWarranty(button, redirectToCart = false) {
  const $cart = $("[data-cart]");
  const $cartLoading =
    '<div class="loading-overlay loading-overlay--custom">\
      <div class="loading-overlay__spinner">\
        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
        </svg>\
      </div>\
    </div>';
  const loadingClass = "is-loading";

  // ✅ Start loading
  $cart.addClass(loadingClass).prepend($cartLoading);

  // add loading on sidebar
  const $cartDropdown = $(
    "#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper"
  );
  const $cartDropdownLoading =
    '<div class="loading-overlay loading-overlay--custom">\
                  <div class="loading-overlay__spinner">\
                      <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
                      </svg>\
                  </div>\
              </div>';
  //const loadingClass = "is-loading";

  $cartDropdown.addClass(loadingClass).prepend($cartDropdownLoading);

  const sideCart = document.querySelector('#halo-cart-sidebar');

  if (sideCart && !sideCart.classList.contains('is-loading-side-cart')) {
    sideCart.classList.add('is-loading-side-cart');
  }

  if (redirectToCart) {
    $(".extend-warranty-btn.btn.protection-add-to-cart-btn").addClass('is-loading');
  }

  try {
    const warrantyData = JSON.parse(button.dataset.warranty);
    const warrantyVariantId = parseInt(warrantyData.warranty_id);
    const mainVariantId = parseInt(warrantyData.product_variant_id);
    const itemQuantity = parseInt(warrantyData.product_qty);
    const cartKey = warrantyData.product_cart_variant_id;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const mainCartItem = cart.items.find(item => item.key === cartKey);

        if (!mainCartItem) {
          throw new Error('Main product not found in cart.');
        }

        // Step 1: Remove main product
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: cartKey, quantity: 0 }),
        }).then(() => mainCartItem);
      })
      .then(mainCartItem => {
        // Step 2: Re-add main product with _variantId reference
        const updatedMainProduct = {
          id: mainVariantId,
          quantity: itemQuantity,
          properties: {
            ...mainCartItem.properties,
            _variantId: String(warrantyVariantId)
          }
        };

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedMainProduct),
        }).then(() => mainCartItem); // Pass to next step
      })
      .then(mainCartItem => {
        // Step 3: Add warranty product

        // Inherit _is_premium from main product if it exists
        const isPremium = mainCartItem.properties && mainCartItem.properties._is_premium;

        const warrantyProperties = {
          [warrantyData.product_title]: warrantyData.product_properties,
          _is_warranty: true,
          _variantId: String(mainVariantId)
        };

        if (isPremium) {
          warrantyProperties._is_premium = true;
        }

        const warrantyItem = {
          id: warrantyVariantId,
          quantity: itemQuantity,
          properties: warrantyProperties,
        };

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(warrantyItem),
        });
      })
      .then(() => {
        console.log("✅ Warranty and main product updated successfully.");
        updateStickyFooterPrice(false); // Or your own callback
      })
      .catch(error => {
        console.error("❌ Warranty add error:", error);
      })
      .finally(() => {
        // ✅ End loading
        //$cart.removeClass("is-loading").find(".loading-overlay--custom").remove();
        setTimeout(function () {
          $cart.removeClass(loadingClass).find(".loading-overlay--custom").remove();
        }, 500);
        if (sideCart && sideCart.classList.contains('is-loading-side-cart')) {
          sideCart.classList.remove('is-loading-side-cart');
        }
        if (redirectToCart) {
          $(".extend-warranty-btn.btn.protection-add-to-cart-btn").removeClass('is-loading');
          window.location.href = "/cart";
        }
      });

  } catch (error) {
    console.error("❌ Invalid warranty data or format:", error);
    $cart.removeClass("is-loading").find(".loading-overlay--custom").remove();
  }
}

function addWarrantyExt(button, redirect = '/cart') {
  $(".extend-warranty-btn.btn.protection-add-to-cart-btn").addClass('is-loading');

  try {
    const warrantyData = JSON.parse(button.dataset.warranty);
    const warrantyVariantId = parseInt(warrantyData.warranty_id);
    const mainVariantId = parseInt(warrantyData.product_variant_id);
    const itemQuantity = parseInt(warrantyData.product_qty);
    const cartKey = warrantyData.product_cart_variant_id;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const mainCartItem = cart.items.find(item => item.key === cartKey);

        if (!mainCartItem) {
          throw new Error('Main product not found in cart.');
        }

        // Step 1: Remove main product
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: cartKey, quantity: 0 }),
        }).then(() => mainCartItem);
      })
      .then(mainCartItem => {
        // Step 2: Re-add main product with _variantId reference
        const updatedMainProduct = {
          id: mainVariantId,
          quantity: itemQuantity,
          properties: {
            ...mainCartItem.properties,
            _variantId: String(warrantyVariantId),
          },
        };

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatedMainProduct),
        }).then(() => mainCartItem); // Pass mainCartItem to the next step
      })
      .then(mainCartItem => {
        // Step 3: Check if warranty already exists before adding
        return fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const existingWarranty = cart.items.find(item =>
              item.variant_id === warrantyVariantId &&
              item.properties &&
              item.properties._is_warranty &&
              item.properties._variantId === String(mainVariantId)
            );

            if (existingWarranty) {
              console.log("✅ Warranty already exists in cart. Skipping re-add.");
              return Promise.resolve();
            }

            // Determine if _is_premium needs to be added
            const isPremium = mainCartItem.properties && mainCartItem.properties._is_premium;

            const warrantyProperties = {
              [warrantyData.product_title]: warrantyData.product_properties,
              _is_warranty: true,
              _variantId: String(mainVariantId),
            };

            if (isPremium) {
              warrantyProperties._is_premium = true;
            }

            const warrantyItem = {
              id: warrantyVariantId,
              quantity: itemQuantity,
              properties: warrantyProperties,
            };

            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(warrantyItem),
            });
          });
      })
      .then(() => {
        console.log("✅ Warranty and main product updated successfully.");
        updateStickyFooterPrice(false); // Optional callback
      })
      .catch(error => {
        console.error("❌ Warranty add error:", error);
      })
      .finally(() => {
        $(".extend-warranty-btn.btn.protection-add-to-cart-btn").removeClass('is-loading');
        window.location.href = redirect;
      });

  } catch (error) {
    console.error("❌ Invalid warranty data or format:", error);
    $(".extend-warranty-btn.btn.protection-add-to-cart-btn").removeClass('is-loading');
  }
}

function updateSidebarCart(cart) {
  var $body = $("body");
  if (!$.isEmptyObject(cart)) {
    const $cartDropdown = $(
      "#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper"
    );
    // const $cartLoading =
    //   '<div class="loading-overlay loading-overlay--custom">\
    //                 <div class="loading-overlay__spinner">\
    //                     <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
    //                         <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
    //                     </svg>\
    //                 </div>\
    //             </div>';
    const loadingClass = "is-loading";

    // if ($cartDropdown.find('.loading-overlay--custom').length === 0) {
    //   $cartDropdown.addClass(loadingClass).prepend($cartLoading);
    // }

    $.ajax({
      type: "GET",
      url: window.routes.root + "/cart?view=ajax_side_cart",
      cache: false,
      success: function (data) {
        var response = $(data);

        $cartDropdown.removeClass(loadingClass).html(response);
      },
      error: function (xhr, text) {
        // alert($.parseJSON(xhr.responseText).description);
        console.log($.parseJSON(xhr.responseText).description);
      },
      complete: function () {
        $body.find("[data-cart-count]").text(cart.item_count);
      },
    });
  }
}

function updateCart(cart, showLoader = true) {
  var $body = $("body");
  if (!$.isEmptyObject(cart)) {
    const $sectionId = $("#main-cart-items").data("id");
    if(!$sectionId){
      return;
    }
    const $cart = $("[data-cart]");
    const $cartContent = $cart.find("[data-cart-content]");
    const $cartTotals = $cart.find("[data-cart-total]");
    if(showLoader){
      const $cartLoading =
        '<div class="loading-overlay loading-overlay--custom">\
                      <div class="loading-overlay__spinner">\
                          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">\
                              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>\
                          </svg>\
                      </div>\
                  </div>';
      const loadingClass = "is-loading";
  
      $cart.addClass(loadingClass).prepend($cartLoading);
    }

    const urlPrefix = window.location.pathname;

    $.ajax({
      type: "GET",
      url: `${urlPrefix}?section_id=${$sectionId}`,
      cache: false,
      success: function (data) {
        var response = $(data);
        // if(showLoader){
        //   $cart.removeClass(loadingClass);
        //   $cart.find(".loading-overlay").remove();
        // }

        if (cart.item_count > 0) {
          var contentCart = response
              .find("[data-cart-content] .cart")
              .html(),
            subTotal = response
              .find("[data-cart-total] .cart-total-subtotal")
              .html(),
            grandTotal = response
              .find("[data-cart-total] .cart-total-grandtotal")
              .html();
          
          var subTotalText = $("<div>" + subTotal + "</div>").find(".cart-total-value .text").text();
          const stickyFooters = document.querySelectorAll(".cart-total-amount-sticky");
          stickyFooters.forEach((stickyFooter) => {
            stickyFooter.innerHTML = subTotalText;
          });

          $cartContent.find(".cart").html(contentCart);
          $cartTotals.find(".cart-total-subtotal").html(subTotal);
          $cartTotals.find(".cart-total-grandtotal").html(grandTotal);

          if (response.find(".haloCalculatorShipping").length > 0) {
            var calculatorShipping = response.find(
              ".haloCalculatorShipping"
            );

            $cart
              .find(".haloCalculatorShipping")
              .replaceWith(calculatorShipping);
          }

          // Re-sync the cashback anchor — its amount threshold only applies to
          // UAE (see main-cart.liquid `show_cashback_threshold`), and this
          // function only ever runs on the cart page (see the template-cart
          // guard around the updateCart() call below).
          if (typeof global_store !== "undefined" && global_store === "uae") {
            var $existingCashbackAnchor = $cartContent.find(".additional-cash-back-anchor");
            var $newCashbackAnchor = response.find(".additional-cash-back-anchor");
            if ($newCashbackAnchor.length > 0) {
              if ($existingCashbackAnchor.length > 0) {
                $existingCashbackAnchor.replaceWith($newCashbackAnchor);
              } else {
                $cartContent.find(".page-header").after($newCashbackAnchor);
              }
            } else {
              $existingCashbackAnchor.remove();
            }
          }
        } else {
          var contentCart = response.find("#main-cart-items").html(),
            headerCart = response.find(".page-header").html();

          $("#main-cart-items").html(contentCart);
          $(".page-header").html(headerCart);
        }
      },
      error: function (xhr, text) {
        // alert($.parseJSON(xhr.responseText).description);
        console.log($.parseJSON(xhr.responseText).description);
      },
      complete: function () {
        $body.find("[data-cart-count]").text(cart.item_count);
      },
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const forms = document.querySelectorAll(
    ".main_product_add_to_cart_form_for_all"
  );

  forms.forEach((form) => {
    form.addEventListener("submit", function (event) {
      event.preventDefault();

      const formData = new FormData(form);
      const productId = formData.get("id");
      const productName = formData.get("pName");
      const productTitle = formData.get("pTitle");
      let productDetails = formData.get("pDetails");
      const productType = formData.get("pType");

      // Set up properties for the main product (unchanged)
      let properties = {
        "Screen Size": jQuery(".screen_size").val(),
      };
      let keyboardValue = jQuery("input[name='keyboards']:checked").val();
      if (keyboardValue !== undefined) {
        properties["Keyboard"] = keyboardValue;
      }

     if (productId in window.fbr_variants) {
    if (document.documentElement.lang === "ar") {
      if (global_store === "za") {
        properties["ريڤايب اكسبرس"] = "توصيل خلال 2-3 أيام";
      } else {
        properties["ريڤايب اكسبرس"] = "توصيل خلال 24 ساعة";
      }
    } else {
      if (global_store === "za") {
        properties["Revibe Express"] = "2-3 Days Delivery";
      } else {
        properties["Revibe Express"] = "24 Hours Delivery";
      }
    }
  }

    let condInputEl = document.querySelector('#laptop_condition');

if (condInputEl && condInputEl.value && condInputEl.value.trim() !== '') {
  if (document.documentElement.lang === "ar") {
    properties["الحالة"] = condInputEl.value.trim();
  } else {
    properties["Condition"] = condInputEl.value.trim();
  }
}

      if (productDetails != '') {
        if (productType != '' && keyboardValue !== undefined) {
          productDetails = productDetails + ' | ' + keyboardValue;
        }
        if (document.documentElement.lang === "ar") {
          properties["التفاصيل"] = productDetails;
        } else {
          properties["Details"] = productDetails;
        }
      }

      // Read warranty control (support both class and id, keep old behavior)
      const warrantyEl =
        document.querySelector(".add_extended_warranty") ||
        document.getElementById("add_extended_warranty");
      let warranty_product = null;
      if (warrantyEl && warrantyEl.value) {
        warranty_product = parseInt(warrantyEl.value, 10);
      }

      // If user actively checked warranty, attach _variantId pre-add (original idea preserved)
      if (warrantyEl && warrantyEl.checked && warranty_product) {
        properties["_variantId"] = String(warranty_product);
      }

      // 1) Add the main product
      addProductToCart(productId, properties)
        // 2) Battery (unchanged)
        .then(() => {
          const batteryCheckbox = document.getElementById("brand_new_battery_checkbox");
          if (batteryCheckbox && batteryCheckbox.checked) {
            return addBatteryProductToCart(productTitle);
          }
        })
        // 3) Warranty SYNC: force warranty if checked OR already existed for this product
        .then(() => {
          if (!warranty_product) return; // nothing to sync if no warranty variant id available
          return syncWarrantyForMain(productId, warranty_product, properties, productName, productDetails);
        })
        // 4) UI and redirects (unchanged logic)
        .then(() => {
          // After adding all selected products, update cart counter
          updateCartCounter();

          // Redirect to cart only if user explicitly checked warranty (unchanged)
          const warrantyCheckbox = document.getElementById("add_extended_warranty");
          const warrantyChecked =
            (warrantyEl && warrantyEl.checked) || (warrantyCheckbox && warrantyCheckbox.checked);

          if (warrantyChecked) {
            if (document.documentElement.lang === "ar") {
              window.location.href = "/ar/cart";
            } else {
              window.location.href = "/cart";
            }
          } else {
            openCartSidebar(productName, productTitle);
            console.log("set warranty Data func");
            setWarrantyData(productId); // unchanged helper for side-cart buttons/prefill
          }
        })
        .catch((error) => {
          console.error("Error adding products to cart:", error);
        });
    });
  });

  /**
   * Ensure warranty is synced with the main product:
   * - If user checked warranty OR a warranty is already present for this product:
   *   - main line item has _variantId set (consolidate duplicates)
   *   - warranty line item exists and its quantity == total main quantity
   */
  function syncWarrantyForMain(productId, warrantyVariantId, mainProps, productName, productDetails) {
    const toInt = (v) => parseInt(v, 10);

    const removeSequentially = (items) =>
      items.reduce(
        (p, item) =>
          p.then(() =>
            fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: item.key, quantity: 0 }),
            })
          ),
        Promise.resolve()
      );

    const updateSequentially = (items) =>
      items.reduce(
        (p, item) =>
          p.then(() =>
            fetch("/cart/change.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              // Shopify supports updating quantity and properties via change.js
              body: JSON.stringify(item),
            })
          ),
        Promise.resolve()
      );

    const addItems = (items) => {
      if (!items || !items.length) return Promise.resolve();
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });
    };

    return fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        const pid = toInt(productId);
        const wid = toInt(warrantyVariantId);

        const mainLines = cart.items.filter((i) => i.variant_id === pid);
        const warrantyLines = cart.items.filter(
          (i) =>
            i.variant_id === wid &&
            i.properties &&
            i.properties._is_warranty &&
            i.properties._variantId === String(pid)
        );

        const totalMainQty = mainLines.reduce((sum, i) => sum + (i.quantity || 0), 0);

        // Nothing to sync if product isn't actually in cart
        if (totalMainQty <= 0) return;

        const mainWithWarranty = mainLines.find((i) => i.properties && i.properties._variantId);
        const mainWithoutWarranty = mainLines.filter((i) => !(i.properties && i.properties._variantId));
        const warrantyExists = warrantyLines.length > 0;

        // If user checked, or warranty already exists for this product, enforce sync
        const checkboxChecked =
          (document.querySelector(".add_extended_warranty") &&
            document.querySelector(".add_extended_warranty").checked) ||
          (document.getElementById("add_extended_warranty") &&
            document.getElementById("add_extended_warranty").checked);

        const shouldAttachWarranty = checkboxChecked || warrantyExists || !!mainWithWarranty;
        if (!shouldAttachWarranty) return; // leave cart as-is

        const itemsToRemove = [];
        const itemsToUpdate = [];
        const itemsToAdd = [];

        // 1) remove any main lines that don't carry _variantId to avoid duplicate lines
        mainWithoutWarranty.forEach((line) => itemsToRemove.push({ key: line.key }));

        // 2) ensure there's one main line with _variantId and correct qty
        const mergedMainProps = {
          ...(mainWithWarranty ? mainWithWarranty.properties || {} : {}),
          ...(mainProps || {}),
          _variantId: String(wid),
        };

        if (mainWithWarranty) {
          itemsToUpdate.push({
            id: mainWithWarranty.key,
            quantity: totalMainQty,
            properties: mergedMainProps,
          });
        } else {
          itemsToAdd.push({
            id: pid,
            quantity: totalMainQty,
            properties: mergedMainProps,
          });
        }

        // 3) ensure warranty line exists and matches main qty
        if (warrantyExists) {
          const wLine = warrantyLines[0];
          if (wLine.quantity !== totalMainQty) {
            itemsToUpdate.push({
              id: wLine.key,
              quantity: totalMainQty,
            });
          }
        } else {
          // Build warranty properties (use productName/productDetails you already have)
          const labelKey = productName || "Warranty of";
          const labelVal = productDetails || "";
          const warrantyProps = {
            [labelKey]: labelVal,
            _is_warranty: true,
            _variantId: String(pid),
          };
          itemsToAdd.push({
            id: wid,
            quantity: totalMainQty,
            properties: warrantyProps,
          });
        }

        // Execute in order: remove -> update -> add
        return removeSequentially(itemsToRemove)
          .then(() => updateSequentially(itemsToUpdate))
          .then(() => addItems(itemsToAdd));
      });
  }

  function setWarrantyData(variant_id) {
    if (!bcpo_product.type.includes("Warranty") && !bcpo_product.type.includes("Accessories")) {

      let attached_variant = "";
      for (const variant of bcpo_product.variants) {
        if (parseInt(variant.id) === parseInt(variant_id)) {
          attached_variant = variant.title;
          if (parseInt(variant.price) === 0 || parseInt(variant.inventory_quantity) === 0) {
            can_order = false;
            break;
          }
        }
      }

      const warranty_id = jQuery(".add_extended_warranty").val();
      const extended_price = jQuery(".extended_warranty_attached_price").val();
      document.getElementById("cart-icon-bubble").click();
      jQuery(".modal-protection-section .modal-content h3 span").html(bcpo_product.title);
      jQuery(".modal-protection-detail-price-box h6").html(global_currency + " " + extended_price);
      jQuery(".main_product_add_to_cart_form .side-cart-warranty-new").val(warranty_id);
      jQuery(".warranty_of").attr("name", "properties[" + bcpo_product.title + "]");
      jQuery(".warranty_of").val(attached_variant);

      fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          const item = cart.items.find((i) => i.variant_id === parseInt(variant_id));
          if (item) {
            const $btn = document.querySelector(".extend-warranty-btn.protection-add-to-cart-btn");
            const data = {
              warranty_id: warranty_id,
              product_variant_id: String(variant_id),
              product_cart_variant_id: item.key,
              product_title: item.product_title,
              product_properties: item.variant_title,
              product_qty: item.quantity,
            };
            if ($btn) {
              $btn.setAttribute("data-warranty", JSON.stringify(data));
            }
          }
        });
    }
  }

  // Function to add a product to the cart
  function addProductToCart(productId, properties) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: productId,
        quantity: 1,
        properties: properties,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to add product to cart");
        }
        return response.json();
      })
      .then((data) => {
        // console.log('Product added to cart:', data);
        return data;
      });
  }

  // Function to add the battery product to the cart
  function addBatteryProductToCart(productTitle) {
    const batteryCheckbox = document.getElementById(
      "brand_new_battery_checkbox"
    );
    if (batteryCheckbox && batteryCheckbox.checked) {
      const batteryProduct = batteryCheckbox.value;
      if (batteryProduct) {
        const labelFor =
          document.documentElement.lang === "ar"
            ? "بطارية جديدة بصحة 100٪؜ لجهاز"
            : "New 100% battery Upgrade for";
        return addProductToCart(batteryProduct, { [labelFor]: productTitle });
      }
    }
    return Promise.resolve(); // Return a resolved promise if no battery product is added
  }

  // Function to add the warranty product to the cart
  function addWarrantyProductToCart(productName, productTitle, variant_id) {
    const warrantyCheckbox = document.getElementById("add_extended_warranty");
    if (warrantyCheckbox && warrantyCheckbox.checked) {
      const warrantyProduct = warrantyCheckbox.value;
      if (warrantyProduct) {
        return addProductToCart(warrantyProduct, {
          [productName]: productTitle,
          _is_warranty: true,
          _variantId: String(variant_id),
        });
      }
    }
    return Promise.resolve(); // Return a resolved promise if no warranty product is added
  }

  // Function to open the mini sidebar cart
  function openCartSidebar(productTitle, attachedVariant) {
    document.getElementById("cart-icon-bubble").click();
    jQuery(".modal-protection-section").css("display", "block");
    jQuery(".custom-side-cart").css("display", "none");

    const warrantyProductAttachedId = jQuery(".add_extended_warranty").val();
    const extendedWarrantyAttachedPrice = jQuery(
      ".extended_warranty_attached_price"
    ).val();

    jQuery(".modal-protection-section .modal-content h3 span").html(
      productTitle
    );
    jQuery(".modal-protection-detail-price-box h6").html(
      global_currency + " " + extendedWarrantyAttachedPrice
    );
    jQuery(".main_product_add_to_cart_form .side-cart-warranty-new").val(
      warrantyProductAttachedId
    );
    jQuery(".warranty_of").attr("name", "properties[" + productTitle + "]");
    jQuery(".warranty_of").val(attachedVariant);
  }

  // Function to update the cart counter
  function updateCartCounter() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        document.getElementById("cart-counter").textContent = cart.item_count;
      });
  }
});